import { render, staticRenderFns } from "./StepLanguages.vue?vue&type=template&id=581625e9&scoped=true&"
import script from "./StepLanguages.vue?vue&type=script&lang=ts&"
export * from "./StepLanguages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581625e9",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VImg,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('581625e9')) {
      api.createRecord('581625e9', component.options)
    } else {
      api.reload('581625e9', component.options)
    }
    module.hot.accept("./StepLanguages.vue?vue&type=template&id=581625e9&scoped=true&", function () {
      api.rerender('581625e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/wizard/StepLanguages.vue"
export default component.exports